/**
 * Enum para los estados posibles de una propina (tip)
 */
export enum TipStatus {
  APROBADA = "APROBADA",
  CANCELADA = "CANCELADA",
  DECLINADA = "DECLINADA",
}

